@if (surveyService.current(); as survey) {
  <section class="survey" role="region" aria-labelledby="aria_survey_question" aria-live="polite">
    @if (surveyService.submitted()) {
      <p class="survey__thanks">
        <mat-icon>check_circle</mat-icon>
        Thanks for your feedback.
      </p>
    } @else {
      <button matIconButton type="button" class="survey__close" aria-label="Dismiss survey"
        (click)="onClick_dismiss()">
        <mat-icon>close</mat-icon>
      </button>
      <h2 id="aria_survey_question" class="survey__question">{{ survey.question }}</h2>

      <!-- Arrow keys bubble up from the focused score button; the group itself is not a stop -->
      <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
      <div class="survey__scores" role="radiogroup" aria-labelledby="aria_survey_question"
        [class.survey__scores--nps]="survey.scale === 'nps10'"
        (keydown)="onKeydown_scoreArrow($event)">
        @for (value of scores; track value) {
          <button type="button" role="radio" class="survey__score"
            [attr.aria-checked]="score() === value"
            [attr.aria-label]="value + ' out of ' + scores[scores.length - 1]"
            [tabindex]="(score() ?? scores[0]) === value ? 0 : -1"
            (click)="onClick_score(value)">
            @if (survey.scale === 'csat5') {
              <mat-icon>{{ faces[value - 1] }}</mat-icon>
            } @else {
              {{ value }}
            }
          </button>
        }
      </div>
      <div class="survey__labels" aria-hidden="true">
        <span>{{ survey.lowLabel }}</span>
        <span>{{ survey.highLabel }}</span>
      </div>

      @if (followUp(); as prompt) {
        <mat-form-field>
          <mat-label>{{ prompt }}</mat-label>
          <textarea matInput rows="2" name="comment" [(ngModel)]="comment"
            [attr.maxlength]="maxComment"></textarea>
          <mat-hint>Optional. Please leave out personal or payment details.</mat-hint>
        </mat-form-field>
        <div class="survey__actions">
          <button matButton="filled" type="button" (click)="onClick_submit()">Send</button>
        </div>
      }
    }
  </section>
}
